import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { EASE, MaskLine, Reveal, SectionLabel } from "./motion";
import { STREAMING } from "@/lib/site";

const PlatformRow = ({ p, i }) => (
  <motion.a
    href={p.href}
    target="_blank"
    rel="noreferrer"
    data-testid={p.testid}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-5% 0px" }}
    transition={{ duration: 0.9, delay: i * 0.1, ease: EASE }}
    className="group relative flex items-center justify-between gap-4 overflow-hidden border-t border-line px-2 py-7 last:border-b sm:px-4 lg:py-9"
  >
    <span className="absolute inset-0 origin-bottom scale-y-0 bg-acid transition-transform [transition-duration:600ms] [transition-timing-function:cubic-bezier(.16,1,.3,1)] group-hover:scale-y-100" />
    <span className="relative z-10 flex items-center gap-5 transition-colors duration-500 group-hover:text-ink sm:gap-8">
      <span className="font-mono text-xs text-smoke transition-colors group-hover:text-ink/60">0{i + 1}</span>
      <i className={`${p.icon} text-2xl sm:text-4xl`} />
      <span className="font-display text-3xl font-bold uppercase tracking-tight transition-transform duration-500 group-hover:translate-x-3 sm:text-5xl lg:text-7xl">{p.name}</span>
    </span>
    <span className="relative z-10 flex items-center gap-4 transition-colors duration-500 group-hover:text-ink">
      <span className="hidden max-w-[220px] text-right font-mono text-[11px] uppercase tracking-[0.2em] text-smoke transition-colors group-hover:text-ink/70 md:block">{p.note}</span>
      <span className="flex h-11 w-11 items-center justify-center rounded-full border border-bone/20 transition-colors group-hover:border-ink sm:h-14 sm:w-14">
        <ArrowUpRight className="h-5 w-5 transition-transform duration-500 group-hover:rotate-45" />
      </span>
    </span>
  </motion.a>
);

export const StreamingStrip = () => (
  <section id="ascolta" data-testid="streaming-section" className="relative px-5 py-24 sm:px-8 lg:px-12 lg:py-36">
    <div className="mb-14 grid gap-8 lg:mb-20 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <SectionLabel index="02">Ascolta ora</SectionLabel>
        <h2 className="mt-6 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskLine>Premi play.</MaskLine>
          <MaskLine delay={0.1} className="text-acid">Ovunque tu sia.</MaskLine>
        </h2>
      </div>
      <Reveal delay={0.2} className="self-end lg:col-span-4 lg:col-start-9">
        <p className="text-base leading-relaxed text-bone/70">
          Tutta la mia musica, sulla piattaforma che preferisci. Scegli dove ascoltarmi, alza il volume e lasciami entrare nelle tue cuffie: il resto lo fanno le canzoni.
        </p>
      </Reveal>
    </div>
    <div>
      {STREAMING.map((p, i) => (
        <PlatformRow key={p.id} p={p} i={i} />
      ))}
    </div>
  </section>
);
